import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  Duration__toString_impl_8d916b11f1kpclwmkpg as Duration__toString_impl_8d916b,
  _Duration___get_inWholeMilliseconds__impl__msfiry1byvgyrhm5g4a as _Duration___get_inWholeMilliseconds__impl__msfiry,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import {
  get_animationsEnabled25ujr8oia8gbs as get_animationsEnabled,
  set_animationsEnabled1ac1lbh50s602 as set_animationsEnabled,
} from '../RView.js.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { lastOrNull1aq5oz189qoe1 as lastOrNull } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { afterTimeout2ddqxaabn39mu as afterTimeout } from '../../afterTimeout.mjs';
import { delay1diib1rb84y4j as delay } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { initMetadataForLambda3af3he42mmnh as initMetadataForLambda } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function nativeSwap(_this__u8e3s4, transition, createNewView) {
  var keyframeName = _this__u8e3s4.pc().qb3_1.ab2(transition);
  var transitionTime = _this__u8e3s4.mba().vb0_1;
  var tmp0_safe_receiver = _this__u8e3s4.sci_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'com.lightningkite.kiteui.views.FutureElement.onElement' call
    var this_0 = tmp0_safe_receiver.vb5_1;
    var tmp0_safe_receiver_0 = this_0.xb3_1;
    var tmp;
    if (tmp0_safe_receiver_0 == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      (tmp0_safe_receiver_0 instanceof HTMLElement ? tmp0_safe_receiver_0 : THROW_CCE()).style.animation = keyframeName + '-exit ' + Duration__toString_impl_8d916b(transitionTime) + ' forwards';
      tmp = Unit_instance;
    }
    if (tmp == null) {
      this_0.wb3_1.v((it) => {
        (it instanceof HTMLElement ? it : THROW_CCE()).style.animation = keyframeName + '-exit ' + Duration__toString_impl_8d916b(transitionTime) + ' forwards';
        return Unit_instance;
      });
    }
    launch(_this__u8e3s4, VOID, VOID, nativeSwap$slambda_0(_this__u8e3s4, tmp0_safe_receiver));
  }
  // Inline function 'com.lightningkite.kiteui.views.withoutAnimation' call
  var tmp_0 = _this__u8e3s4.vb5_1.xb3_1;
  var tmp0_safe_receiver_1 = tmp_0 instanceof HTMLElement ? tmp_0 : null;
  var tmp_1;
  if (tmp0_safe_receiver_1 == null) {
    tmp_1 = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'com.lightningkite.kiteui.views.withoutAnimation' call
    var this_1 = tmp0_safe_receiver_1;
    var animate = get_animationsEnabled();
    try {
      if (animate) {
        set_animationsEnabled(false);
        // Inline function 'com.lightningkite.kiteui.views.direct.suppressMutationObserverForClass' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp_2 = this_1.__suppressMutationObserverClass;
        var tmp0_elvis_lhs = tmp_2 instanceof ArrayList() ? tmp_2 : null;
        var tmp_3;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.run' call
          var n = ArrayList().w();
          // Inline function 'kotlin.js.asDynamic' call
          this_1.__suppressMutationObserverClass = n;
          tmp_3 = n;
        } else {
          tmp_3 = tmp0_elvis_lhs;
        }
        var e = tmp_3;
        this_1.classList.add('notransition');
        var tmp1_elvis_lhs = this_1.getAttribute('class');
        e.v(tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
      }
      createNewView(_this__u8e3s4);
    }finally {
      if (animate) {
        var tmp_4 = window;
        tmp_4.setTimeout(() => {
          // Inline function 'com.lightningkite.kiteui.views.direct.suppressMutationObserverForClass' call
          var this_0 = this_1;
          // Inline function 'kotlin.js.asDynamic' call
          var tmp = this_0.__suppressMutationObserverClass;
          var tmp0_elvis_lhs = tmp instanceof ArrayList() ? tmp : null;
          var tmp_0;
          if (tmp0_elvis_lhs == null) {
            // Inline function 'kotlin.run' call
            var n = ArrayList().w();
            // Inline function 'kotlin.js.asDynamic' call
            this_0.__suppressMutationObserverClass = n;
            tmp_0 = n;
          } else {
            tmp_0 = tmp0_elvis_lhs;
          }
          var e = tmp_0;
          this_1.classList.remove('notransition');
          var tmp1_elvis_lhs = this_0.getAttribute('class');
          e.v(tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
          return Unit_instance;
        }, 100);
        set_animationsEnabled(true);
      }
    }
    tmp_1 = Unit_instance;
  }
  if (tmp_1 == null) {
    createNewView(_this__u8e3s4);
  }
  // Inline function 'kotlin.takeUnless' call
  var this_2 = lastOrNull(_this__u8e3s4.qba());
  var tmp_5;
  if (!equals(this_2, _this__u8e3s4.sci_1)) {
    tmp_5 = this_2;
  } else {
    tmp_5 = null;
  }
  var tmp1_safe_receiver = tmp_5;
  var tmp_6;
  if (tmp1_safe_receiver == null) {
    tmp_6 = null;
  } else {
    // Inline function 'kotlin.let' call
    _this__u8e3s4.sci_1 = tmp1_safe_receiver;
    _this__u8e3s4.jb7(true);
    // Inline function 'com.lightningkite.kiteui.views.FutureElement.onElement' call
    var this_3 = tmp1_safe_receiver.vb5_1;
    var tmp0_safe_receiver_2 = this_3.xb3_1;
    var tmp_7;
    if (tmp0_safe_receiver_2 == null) {
      tmp_7 = null;
    } else {
      // Inline function 'kotlin.let' call
      (tmp0_safe_receiver_2 instanceof HTMLElement ? tmp0_safe_receiver_2 : THROW_CCE()).style.animation = keyframeName + '-enter ' + Duration__toString_impl_8d916b(transitionTime) + ' forwards';
      tmp_7 = Unit_instance;
    }
    if (tmp_7 == null) {
      this_3.wb3_1.v((it) => {
        (it instanceof HTMLElement ? it : THROW_CCE()).style.animation = keyframeName + '-enter ' + Duration__toString_impl_8d916b(transitionTime) + ' forwards';
        return Unit_instance;
      });
    }
    tmp_6 = Unit_instance;
  }
  if (tmp_6 == null) {
    // Inline function 'kotlin.run' call
    var $this$run = _this__u8e3s4;
    $this$run.sci_1 = null;
    if ($this$run.yb8()) {
      var tmp_8 = _Duration___get_inWholeMilliseconds__impl__msfiry(transitionTime);
      afterTimeout($this$run, tmp_8, () => {
        $this$run.jb7(false);
        return Unit_instance;
      });
    }
  }
}
function *_generator_invoke__zhh2q8($this, $this$launch, $completion) {
  var tmp = delay($this.ldq_1.mba().vb0_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  $this.ldq_1.uba($this.mdq_1);
  return Unit_instance;
}
var nativeSwap$slambdaClass;
function nativeSwap$slambda() {
  if (nativeSwap$slambdaClass === VOID) {
    class $ {
      constructor($this_nativeSwap, $view) {
        this.ldq_1 = $this_nativeSwap;
        this.mdq_1 = $view;
      }
      yah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    nativeSwap$slambdaClass = $;
  }
  return nativeSwap$slambdaClass;
}
function nativeSwap$slambda_0($this_nativeSwap, $view) {
  var i = new (nativeSwap$slambda())($this_nativeSwap, $view);
  var l = ($this$launch, $completion) => i.yah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
//region block: exports
export {
  nativeSwap as nativeSwap3qcor1bahhtzn,
};
//endregion

//# sourceMappingURL=SwapView.commonHtml.js.mjs.map
